import src from "IMAGE";
export default { src, width: 241, height: 102, blurWidth: 0, blurHeight: 0};
